import { useEffect, useState } from 'react';

import { GraduationCap } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@alamo/ui';

const SESSION_KEY = 'consultant_onboarding_welcome_seen';

interface OnboardingWelcomeDialogProps {
  blocked: boolean;
}

export function OnboardingWelcomeDialog({ blocked }: OnboardingWelcomeDialogProps) {
  const { t } = useTranslation('pre_approval');
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!blocked) {
      setOpen(false);
      return;
    }
    try {
      setOpen(sessionStorage.getItem(SESSION_KEY) !== 'true');
    } catch {
      setOpen(true);
    }
  }, [blocked]);

  const markSeen = () => {
    setOpen(false);
    try {
      sessionStorage.setItem(SESSION_KEY, 'true');
    } catch {
      // sessionStorage may be unavailable
    }
  };

  return (
    <Dialog open={blocked && open} onOpenChange={(nextOpen) => !nextOpen && markSeen()}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <GraduationCap className="h-5 w-5 text-primary-600" aria-hidden="true" />
            {t('welcome.title')}
          </DialogTitle>
          <DialogDescription className="pt-2 text-left leading-6">
            {t('welcome.description')}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button asChild onClick={markSeen}>
            <Link to="/training">{t('welcome.action')}</Link>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
